export enum ColonistMembershipPerkType {
    AllMaps,
    AllExpansions,
    RankedGames,
    CustomLinks,
    ColonistCoins,
    NoAds,
    AllColors,
    BasicReplay,
    FullReplay,
}
